module.exports = __webpack_public_path__ + "img/astro2.8a9222f3.jpg";